import FrontPageView from './FrontPageView';
import ImageView from './ImageView';
import ConfigView from './ConfigView';

export {
    ImageView,
    FrontPageView,
    ConfigView
};



// WEBPACK FOOTER //
// ./~/@girder/histomicsui/views/body/index.js